import { Action } from '@ngrx/store';

export enum MediaWallActionTypes {
  INIT_MEDIA_WALL = '[Cyclops Media Wall] Init Media Wall',
  LOAD_ASSETS_DATA = '[Cyclops Media Wall] Load Assets Data',
  LOAD_ASSETS_DATA_SUCCESS = '[Cyclops Media Wall] Load Assets Data Success',
  LOAD_ASSETS_DATA_FAILURE = '[Cyclops Media Wall] Load Assets Data Failue',
  SAVE_ASSET_SETTING = '[Cyclops Media Wall] Save Asset',
  SAVE_ASSET_SETTING_SUCCESS = '[Cyclops Media Wall] Save Asset Success',
  SAVE_ASSET_SETTING_FAILURE = '[Cyclops Media Wall] Save Asset Failue',
  GET_UPDATED_ASSET_SETTING = '[Cyclops Media Wall] Get Updated Asset Setting',
  GET_UPDATED_ASSET_SETTING_SUCCESS = '[Cyclops Media Wall] Get Updated Asset Setting Success',
  GET_UPDATED_ASSET_SETTING_FAILURE = '[Cyclops Media Wall] Get Updated Asset Setting Failue',
  START_COMPUTER_VISION = '[Cyclops Media Wall] Start Computer Vision',
  START_COMPUTER_VISION_SUCCESS = '[Cyclops Media Wall] Start Computer Vision Success',
  START_COMPUTER_VISION_FAILURE = '[Cyclops Media Wall] Start Computer Vision Failue',
  LOAD_ASSET_SETTINGS = '[Cyclops Media Wall] Load Assets Settings',
  LOAD_ASSET_SETTINGS_SUCCESS = '[Cyclops Media Wall] Load Assets Settings Success',
  LOAD_ASSET_SETTINGS_FAILURE = '[Cyclops Media Wall] Load Assets Settings Failue',
  GET_ZOOMED_ASSET_FRAME = '[Cyclops Media Wall] Get Zoomed Asset Frame',
  GET_ZOOMED_ASSET_FRAME_SUCCESS = '[Cyclops Media Wall] Get Zoomed Asset Frame Success',
  GET_ZOOMED_ASSET_FRAME_FAILURE = '[Cyclops Media Wall] Get Zoomed Asset Frame Failue',
  SET_CONTEXT_DATA = '[Cyclops Media Wall] Set Context Data',
  RESET_STATE = '[Cyclops Media Wall] Reset State',
}
export class ResetState implements Action {
  readonly type = MediaWallActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class InitMediaWall implements Action {
  readonly type = MediaWallActionTypes.INIT_MEDIA_WALL;
  constructor(public payload: any) {}
}
export class LoadAssetsData implements Action {
  readonly type = MediaWallActionTypes.LOAD_ASSETS_DATA;
  constructor(public payload: any) {}
}
export class LoadAssetsDataSuccess implements Action {
  readonly type = MediaWallActionTypes.LOAD_ASSETS_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class LoadAssetsDataFailure implements Action {
  readonly type = MediaWallActionTypes.LOAD_ASSETS_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class LoadAssetSettingsData implements Action {
  readonly type = MediaWallActionTypes.LOAD_ASSET_SETTINGS;
  constructor(public payload: any) {}
}
export class LoadAssetSettingsDataSuccess implements Action {
  readonly type = MediaWallActionTypes.LOAD_ASSET_SETTINGS_SUCCESS;
  constructor(public payload: any) {}
}
export class LoadAssetSettingsDataFailure implements Action {
  readonly type = MediaWallActionTypes.LOAD_ASSET_SETTINGS_FAILURE;
  constructor(public payload: any) {}
}
export class SetContextData implements Action {
  readonly type = MediaWallActionTypes.SET_CONTEXT_DATA;
  constructor(public payload: any) {}
}
export class SaveAssetSetting implements Action {
  readonly type = MediaWallActionTypes.SAVE_ASSET_SETTING;
  constructor(public payload: any) {}
}
export class SaveAssetSettingSuccess implements Action {
  readonly type = MediaWallActionTypes.SAVE_ASSET_SETTING_SUCCESS;
  constructor(public payload: any) {}
}
export class SaveAssetSettingFailure implements Action {
  readonly type = MediaWallActionTypes.SAVE_ASSET_SETTING_FAILURE;
  constructor(public payload: any) {}
}

export class GetUpdatedAssetSetting implements Action {
  readonly type = MediaWallActionTypes.GET_UPDATED_ASSET_SETTING;
  constructor(public payload: any) {}
}
export class GetUpdatedAssetSettingSuccess implements Action {
  readonly type = MediaWallActionTypes.GET_UPDATED_ASSET_SETTING_SUCCESS;
  constructor(public payload: any) {}
}
export class GetUpdatedAssetSettingFailure implements Action {
  readonly type = MediaWallActionTypes.GET_UPDATED_ASSET_SETTING_FAILURE;
  constructor(public payload: any) {}
}
export class StartComputerVision implements Action {
  readonly type = MediaWallActionTypes.START_COMPUTER_VISION;
  constructor(public payload: any) {}
}
export class StartComputerVisionSuccess implements Action {
  readonly type = MediaWallActionTypes.START_COMPUTER_VISION_SUCCESS;
  constructor(public payload: any) {}
}
export class StartComputerVisionFailure implements Action {
  readonly type = MediaWallActionTypes.START_COMPUTER_VISION_FAILURE;
  constructor(public payload: any) {}
}
export class GetZoomedAssetFrame implements Action {
  readonly type = MediaWallActionTypes.GET_ZOOMED_ASSET_FRAME;
  constructor(public payload: any) {}
}
export class GetZoomedAssetFrameSuccess implements Action {
  readonly type = MediaWallActionTypes.GET_ZOOMED_ASSET_FRAME_SUCCESS;
  constructor(public payload: any) {}
}
export class GetZoomedAssetFrameFailure implements Action {
  readonly type = MediaWallActionTypes.GET_ZOOMED_ASSET_FRAME_FAILURE;
  constructor(public payload: any) {}
}
export type CyclopsMediWallActionUnion =
  | ResetState
  | InitMediaWall
  | LoadAssetsData
  | LoadAssetsDataSuccess
  | LoadAssetsDataFailure
  | SetContextData
  | SaveAssetSetting
  | SaveAssetSettingSuccess
  | SaveAssetSettingFailure
  | StartComputerVision
  | StartComputerVisionSuccess
  | StartComputerVisionFailure
  | LoadAssetSettingsData
  | LoadAssetSettingsDataSuccess
  | LoadAssetSettingsDataFailure
  | GetZoomedAssetFrame
  | GetZoomedAssetFrameSuccess
  | GetZoomedAssetFrameFailure
  | GetUpdatedAssetSetting
  | GetUpdatedAssetSettingSuccess
  | GetUpdatedAssetSettingFailure;
